module.exports = __webpack_public_path__ + "static/media/2.8141e5ea.svg";